var map = {
	"./1.jpg": "b087",
	"./2.jpg": "bf41",
	"./3.jpg": "91bc",
	"./4.jpg": "5b7b",
	"./5.jpg": "6fe1",
	"./6.jpg": "e9e0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a226";